<template>
  <div>
    <app-shop></app-shop>
    <app-sponsors></app-sponsors>
  </div>
</template>
<script>
import Shop from "@/components/shared/Shop";
import Sponsors from "@/components/shared/Sponsors";
export default {
  name: "DefaultLayout",
  components: {
    "app-shop": Shop,
    "app-sponsors": Sponsors,
  },
};
</script>